export default "__VITE_ASSET__7276270b__"